export const DEFAULT_SKIN = 'light';
